import SanityBlockRenderer from 'components/sanity-block-renderer';

export const DescriptionTextBlock = SanityBlockRenderer.withConfig({
  textProps: {
    fontSize: 'xs',
    lineHeight: 'md',
  },
});
